module.exports = __webpack_public_path__ + "img/project_e4.8528bb1f.jpg";